import HttpRequest, { type RequestResult } from "../request";
import type { uploadFileInfo } from "./types";
import type { Response } from "../request";
import { CommonApi, UploadApi } from "../api";
import eventBus from 'vue3-eventbus'

export default {
    getUploadFile(params: {data: FormData}): RequestResult<uploadFileInfo> {
        const result = HttpRequest.post<uploadFileInfo>(UploadApi.getUploadFile, params, {uploadFlag: true, onProgress: (progress) => {
            eventBus.emit("onUploadProgress", {progress: progress})
        }}) as RequestResult<uploadFileInfo>
        return result
    },
    getOperateRecordLogs(): Promise<Response<[]>> {
        return HttpRequest.get(CommonApi.operateRecordLogs, null)
    },
    // 获取文件记录信息
    getFileRecord(params:{fileRecordId:number}): Promise<Response<[]>> {
        return HttpRequest.get(CommonApi.fileRecord, { fileRecordId: params.fileRecordId })
    },
    // 执行ocr 识别功能，
    actuatorOcr(params: {fileRecordId: number, ocrPages?: number}): Promise<Response<string>> {
        const requestParams: any = { fileRecordId: params.fileRecordId };
        // 如果指定了 ocrPages，则添加到请求参数中
        if (params.ocrPages !== undefined) {
            requestParams.ocrPages = params.ocrPages;
        }
        return HttpRequest.post<string>(CommonApi.todoOcr, requestParams) as Promise<Response<string>>
    },
    // 获取下载文件地址
    getDownloadFileUrl(params: {fileRecordId: number, fileType: string}): Promise<Response<string>> {
        return HttpRequest.post<string>(CommonApi.getDownloadFileUrl, {fileRecordId: params.fileRecordId, fileType: params.fileType}) as Promise<Response<string>>
    },
    // 销毁文件
    getRecordDestroy(params: {fileRecordId: number}): Promise<Response<string>> {
        return HttpRequest.post<string>(CommonApi.getRecordDestroy, { fileRecordId: params.fileRecordId }) as Promise<Response<string>>
    },
    // 客户端通知“服务器”记录操作日志
    getNoticeOperate(params: {operateType: number, fileRecordId: number}): Promise<Response<string>> {
        return HttpRequest.post<string>(
            CommonApi.getNoticeOperate,
            { operateType: params.operateType, fileRecordId: params.fileRecordId }
        ) as Promise<Response<string>>
    },
    // 更新文件的“操作时间”
    getRenewFileOperateTime(params: {fileRecordId: number}): Promise<Response<string>> {
        return HttpRequest.post<string>(CommonApi.getRenewFileOperateTime, { fileRecordId: params.fileRecordId }) as Promise<Response<string>>
    },
    // 获取AWS 亚马逊上传文件的地址URL
    getAwsUploadFileUrl(params: {fileRecordId: number}): Promise<Response<string>> {
        return HttpRequest.get<string>(CommonApi.getAwsUploadFileUrl, { fileRecordId: params.fileRecordId }) as Promise<Response<string>>
    },
    
    // 轮询获取 ocr 返回地址、下载文件返回地址（GET，参数仅 logId）
    getPollingAwsUploadFileUrl(params: { logId: number }): Promise<Response<any>> {
        return HttpRequest.get<any>(CommonApi.getPollingAwsUploadFileUrl, { logId: params.logId }) as Promise<Response<any>>
    },
    /** 轮询获取 AWS 文件 URL（上传/下载），根据 status 完成则停止 */
    async pollAwsFileUrl(params: { logId: number }): Promise<Response<any> | null> {
        const POLL_INTERVAL = 5000;
        let response: Response<any> | null = null;
        while (true) {
            response = await this.getPollingAwsUploadFileUrl(params);
            if ((response as any).data?.status === 2) break;
            if (response.code !== '1') break;
            await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL));
        }
        return response;
    },
}